import React from 'react'

const CookiePopup = ({dispatch}) => {
  return (
    <div id="cookieConsent">
    <div id="closeCookieConsent" onClick={() => dispatch({ type: 'declineAll' })}>x</div>
    Sütiket és más technológiát használunk a weboldal működéséhez, statisztikához, a tartalmak és hirdetések, ajánlatok személyre szabásához, és az így gyűjtött adatok média-, hirdető- és elemző partnereinkkel történő megosztásához. Partnereink ezeket kombinálhatják más adatokkal is. Az Elfogadom gombra kattintással hozzájárulsz mindezekhez. {/* A hozzájárulásod tartalmát a További beállítások gomb alatt állíthatod be, amit bármikor módosíthatsz. */} Részletes <a href={`${process.env.PUBLIC_URL}/cookie-policy/`} >  süti tájékoztató.</a> <a className="cookieConsentOK" onClick={() => dispatch({ type: 'acceptCurrent' })}>Elfogadom</a>
    </div>
  );
}

export default CookiePopup

/*


  <section>
    <p>We use cookies!</p>
    <button >Accept</button>
    <button onClick={() => dispatch({type: 'declineAll'})}>Decline</button>
  </section>


*/